import React from "react";
import { View, Text } from "react-native";

export const BoldText = ({ children }) => {
  return (children || "").split("*").map((word, index) => (
    <Text key={word + index} style={[index % 2 && styles.bold]}>
      {word}
    </Text>
  ));
};

export const MarkdownText = ({ children }) => {
  return (children || "").split("\\n").map((line, index) => (
    <View style={styles.paragraph} key={line + index}>
      <Text>
        <BoldText>{line || " "}</BoldText>
      </Text>
    </View>
  ));
};

const styles = {
  paragraph: { display: "flex" },
  bold: { fontWeight: "bold" },
};
